const orgSchema = {
  $id: "/org",
  title: "Organization",
  type: "object",
  properties: {
    id: { type: "string", format: "uuid", readOnly: true },
    config: {
      type: "object",
      properties: {
        userCount: {
          type: "number",
          minimum: 1,
        },
        additionalProperties: true,
      },
    },
    created: { type: "string", format: "date-time", readOnly: true },
    createdBy: { type: "string", format: "uuid", readOnly: true },
    locations: { type: "array", items: { $ref: "/location" }, readOnly: true },
    market: { type: "number" },
    modified: { type: "string", format: "date-time", readOnly: true },
    modifiedBy: { type: "string", format: "uuid", readOnly: true },
    name: { type: "string", minLength: 1, maxLength: 255 },
    notes: { type: "string", maxLength: 255 },
    orgType: { type: "string" },
    persons: {
      type: "array",
      readOnly: true,
      items: {
        type: "object",
        properties: {
          id: { type: "string", format: "uuid" },
          created: { type: "string", readOnly: true },
          email: { type: "string", format: "email" },
          firstName: { type: "string" },
          lastName: { type: "string" },
          lastLoginAt: { type: "string", readOnly: true, nullable: true },
          rolesInOrg: {
            type: "array",
            items: { type: "number" },
          },
        },
      },
    },
    shortName: { type: "string", maxLength: 255 },
    status: { type: "number", readOnly: true },
    webUrl: { type: "string", maxLength: 255 },
    stripeCustomerId: { type: "string" },
    autoIsolationEnabled: { type: "boolean" },
    autoIsolationTypes: { type: "array", items: { type: "string" } },
    agentSeatCount: { type: "number" },
    license: { type: "string" },
    licenseFeatures: {
      type: "array",
      items: { type: "string" },
    },
    parentId: { type: "string", format: "uuid", nullable: true },
  },
  required: ["name"],
  additionalProperties: false,
};

export default orgSchema;
